import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth'

const SideNav = () => (
    <div id="side-menu" className="side-nav st-menu st-effect-1">
        <div className="side-nav__items">
            <Link to="/expenses">Expenses</Link>
            <Link to="/dashboard">Accounts</Link>
            <Link to="/category">Category</Link>
            <Link to="/dashboard">Profile</Link>
        </div>
        <div className="side-nav__button">
            <button className="button button--link" onClick={startLogout()}>Logout</button>
        </div>
    </div>
)


const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
});

export default connect(undefined, mapDispatchToProps)(SideNav);


// WEBPACK FOOTER //
// ./src/components/SideNav.js